import { queryOptions, useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api-client'
import { QueryConfig } from '@/lib/react-query'

export type AccountWithSubscriptionType = {
    accountId: string
    name: string
    email: string
    phone: string
    city: string | null
    state: string | null
    isDisabled: boolean
    subscriptionCount: number
}

export const getAccountsWithFastboundSubscriptions = (): Promise<AccountWithSubscriptionType[]> => {
    return api.get('/v2/subscription-reports/accounts-with-fastbound-subscriptions')
}

export const getAccountsWithFastboundSubscriptionsQueryOptions = () => {
    return queryOptions({
        queryKey: ['subscription-reports', 'accounts-with-fastbound-subscriptions'],
        queryFn: () => getAccountsWithFastboundSubscriptions(),
    })
}

type UseAccountsWithFastboundSubscriptionsOptions = {
    queryConfig?: QueryConfig<typeof getAccountsWithFastboundSubscriptions>
}

export const useAccountsWithFastboundSubscriptions = ({ queryConfig }: UseAccountsWithFastboundSubscriptionsOptions = {}) => {
    return useQuery({
        ...getAccountsWithFastboundSubscriptionsQueryOptions(),
        ...queryConfig,
    })
}

